//Stateler çekilip return edilecek

export const companyId = (state) => {
    return state.companyId
}

export const getDealerLoading = (state) => {
    return state.loading
}

export const getCompanyPageInfo = (state) => {
    return state.companyPageInfo
}

export const getCompanies = (state) => {
    return state.companies
}

export const getCompany = (state) => {
    return state.company
}

export const getCompanyTypes = (state) => {
    return state.companyTypes
}

export const getCompanyStatus = (state) => {
    return state.companyStatus
}

export const getCompanyAddresses = (state) => {
    return state.addresses
}

export const getCompanyAddressStatus = (state) => {
    return state.addressStatus
}

export const getCompanyUsers = (state) => {
    return state.users
}

export const getCompanyUserStatus = (state) => {
    return state.userStatus
}

export const getServiceForm = (state) => {
    return state.serviceFormStatus
}

export const serviceFormList = (state) => {
    return state.serviceForms
}

export const getServiceFormPageInfo = (state) => {
    return state.serviceFormPageInfo
}

export const serviceMovementsList = (state) => {
    return state.serviceFormMovements
}

export const getServiceFormPhoto = (state) => {
    return state.serviceFormMovePhotoStatus
}

export const getServiceFormDetail = (state) => {
    return state.serviceFormDetail
}






// WEBPACK FOOTER //
// ./src/store/modules/Dealer/Getters.js